import { Pipe, PipeTransform } from '@angular/core';
import { FormListEntryState } from '../../../types/form-list';
import { FormsConstants } from '../../../types/forms-constants';

@Pipe({
    name: 'formsListSubmitStatus',
})
export class FormsListSubmitStatusPipe implements PipeTransform {
    public transform(value: FormListEntryState): string {
        // this is the case if the form was submitted on another device and we don't have information in which status the form was submitted
        const isPreviousSubmitAndUnknownStatus =
            value.previousSubmit && value.submitStatus === FormsConstants.SUBMIT_STATUS.UNKNOWN;

        if (isPreviousSubmitAndUnknownStatus) {
            return 'SELECT_FORM_SUBMIT_STATUS_S';
        } else {
            return `SELECT_FORM_SUBMIT_STATUS_${value.submitStatus}`;
        }
    }
}
